<template>
  <div class="container-fluid">
    <div class="flex w-full justify-center items-center h-auto">
      <div id="pythonApi" class="flex flex-col items-center justify-center w-1/2 p-6">
        <p class="font-light text-base lg:text-lg xl:text-xl 3xl:text-2xl text-center">
          The TransMAP Python API is an interface for searching, retrieving and manipulating datasets registered in the data hub. Users can
          create a <a class="text-blue-700 font-medium" href="https://jupyter.org/" target="_blank">Jupyter notebook</a>, then use this
          package to work directly with the hub datasets to perform the desired analysis.
        </p>
        <button
          type="button"
          class="mt-6 rounded inline-block px-6 py-2.5 bg-blue-700 text-white font-medium text-xs leading-tight uppercase hover:bg-blue-600 disabled:bg-gray-500"
          @click.prevent="getDownload()"
        >
          Click here to Download Tansmap python Package
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import axios from 'axios'
export default {
  name: 'PythonApiSection',
  setup() {
    let file = {}
    const errorMessage = ref('')
    const preparingDownload = ref(false)
    const getDownload = async () => {
      preparingDownload.value = true
      axios
        .get(`${process.env.BASE_URL}transmap-1.0.1-py3-none-any.whl`, { responseType: 'blob' })
        .then(async (response) => {
          if (!response.status === 200) {
            errorMessage.value = 'Download Failed'
            throw new Error(errorMessage.value)
          } else {
            file = new Blob([response.data], { type: 'application/zip' })
            preparingDownload.value = false
            download()
          }
        })
        .catch((error) => {
          console.log('error')
          console.log(error)
          errorMessage.value = error.response?.statusText || 'Download Failed'
          alert(errorMessage.value)
        })
    }
    const download = () => {
      const link = document.createElement('a')
      link.href = URL.createObjectURL(file)
      link.download = 'transmap-1.0.1-py3-none-any.whl'
      link.click()
      URL.revokeObjectURL(link.href)
    }
    return {
      getDownload,
      errorMessage,
    }
  },
}
</script>

<style>

</style>
